import { Eye, EyeOff, DollarSign, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTableConsumptionSettings } from "@/hooks/useTableConsumptionSettings";

const INACTIVITY_OPTIONS = [
  { value: 5, label: "5 minutos" },
  { value: 10, label: "10 minutos" },
  { value: 15, label: "15 minutos" },
  { value: 20, label: "20 minutos" },
  { value: 30, label: "30 minutos" },
  { value: 45, label: "45 minutos" },
  { value: 60, label: "1 hora" },
];

export function TableConsumptionSettingsCard() {
  const { 
    showTableConsumptionValue, 
    tableInactivityMinutes,
    isUpdating, 
    updateShowConsumption,
    updateInactivityMinutes 
  } = useTableConsumptionSettings();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <DollarSign className="h-5 w-5" />
          Exibição de Valores
        </CardTitle>
        <CardDescription>
          Configure como os valores de consumo são exibidos nas mesas
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between rounded-lg border p-4">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center">
              {showTableConsumptionValue ? (
                <Eye className="h-4 w-4 text-primary" />
              ) : (
                <EyeOff className="h-4 w-4 text-muted-foreground" />
              )}
            </div>
            <div>
              <Label className="text-base">Mostrar valor na seleção de mesas</Label>
              <p className="text-sm text-muted-foreground">
                Exibe o valor atual de consumo ao lado de cada mesa ocupada no PDV
              </p>
            </div>
          </div>
          <Switch
            checked={showTableConsumptionValue}
            onCheckedChange={updateShowConsumption}
            disabled={isUpdating}
          />
        </div>

        <div className="flex items-center justify-between rounded-lg border p-4">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-lg bg-destructive/10 flex items-center justify-center">
              <Clock className="h-4 w-4 text-destructive" />
            </div>
            <div>
              <Label className="text-base">Alerta de inatividade</Label>
              <p className="text-sm text-muted-foreground">
                Mesas ficam vermelhas após este tempo sem novo consumo
              </p>
            </div>
          </div>
          <Select
            value={tableInactivityMinutes.toString()}
            onValueChange={(value) => updateInactivityMinutes(parseInt(value))}
            disabled={isUpdating}
          >
            <SelectTrigger className="w-32">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {INACTIVITY_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value.toString()}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
